import { render, staticRenderFns } from "./OffAccount.vue?vue&type=template&id=428ccb9e&scoped=true"
import script from "./OffAccount.vue?vue&type=script&lang=js"
export * from "./OffAccount.vue?vue&type=script&lang=js"
import style0 from "./OffAccount.vue?vue&type=style&index=0&id=428ccb9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428ccb9e",
  null
  
)

export default component.exports